// Orange2 layout entrypoint
// Migrated from app/assets/javascripts/orange2.js

import Fingerprint2 from 'fingerprintjs2'
window.Fingerprint2 = Fingerprint2

import 'libraries/globals' // jQuery, angular, underscore as window globals
import 'angular-resource'
import 'vendor/checklist-model'
import 'jquery-ujs'
import 'vendor/bootstrap-validator'
// i18n + i18n/translations loaded via <script> tags in layout (gem-generated)
import 'popper.js'
import 'bootstrap'
import 'vendor/ui-bootstrap-tpls-0.3.3'
import 'vendor/bootbox-4.3.0'
import 'libraries/service-cost'
import 'libraries/order'
// resizer + iframeResizer.contentWindow loaded as sync <script> in layout
import toastr from 'toastr'
window.toastr = toastr
import 'intl-tel-input'
import 'libraries/idle'
import 'libraries/orange2-legacy'
import 'libraries/share-panel'

// Manual Angular bootstrap - required because Vite modules are deferred
// and ng-app auto-bootstrap may fire before myApp module is registered.
// ng-app="myApp" has been removed from the layout's <html> tag.
document.addEventListener('DOMContentLoaded', function() {
  window.angular.bootstrap(document, ['myApp'])
})
